module.exports = __webpack_public_path__ + "static/media/watch-with-blank-face.8ffcc504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/watch-with-blank-face.svg
// module id = 190
// module chunks = 0